import { Posting } from './posting.model';
import { IMaxbrainImageQuery } from '../../image-library/interfaces/maxbrain-image.interface';
import { MaxbrainImage } from '../../image-library/models/maxbrain-image.model';

/**
 *  Transform Entity Posting to  a future Json Posting Image class
 */
export class PostingImageCommand implements IMaxbrainImageQuery {
    id: string;
    unsplash: {
        unsplash_id: string;
        author_name: string;
        author_profile_url: string;
        author_profile_image: string;
    };
    url: string;
    small_url: string;
    thumb_url: string;
    large_url: string;

    /**
     * Can be build from Posting or MaxbrainImage
     * @param tempPosting
     * @param image
     */
    constructor(tempPosting?: Posting, image?: MaxbrainImage) {
        if (tempPosting) {
            this.id = tempPosting.image.id;
            this.url = tempPosting.image.url;
            this.small_url = tempPosting.image.smallUrl;
            this.thumb_url = tempPosting.image.thumbUrl;
            this.large_url = tempPosting.image.largeUrl;
            if (tempPosting.image.unsplash) {
                this.unsplash = {
                    unsplash_id: tempPosting.image.unsplash.unsplashId,
                    author_name: tempPosting.image.unsplash.authorName,
                    author_profile_url: tempPosting.image.unsplash.authorProfileUrl,
                    author_profile_image: tempPosting.image.unsplash.authorProfileImage,
                };
            }
        } else if (image) {
            this.id = image.id;
            this.url = image.url;
            this.small_url = image.smallUrl;
            this.thumb_url = image.thumbUrl;
            this.large_url = image.largeUrl;

            if (image.unsplash) {
                this.unsplash = {
                    unsplash_id: image.unsplash.unsplashId,
                    author_name: image.unsplash.authorName,
                    author_profile_url: image.unsplash.authorProfileUrl,
                    author_profile_image: image.unsplash.authorProfileImage,
                };
            }
        }
    }
}
